import {inputsConfigs} from './inputs';
import {navigationConfigs} from './navigation';
import {surfaceConfigs} from './surfaces';
import {feedbackConfigs} from './feedback';
import {dataDisplayConfigs} from './dataDisplay';
import {utilConfigs} from './util';

export const muiComponentConfigs = [
  ...inputsConfigs,
  ...navigationConfigs,
  ...surfaceConfigs,
  ...feedbackConfigs,
  ...dataDisplayConfigs,
  ...utilConfigs,
];
